import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { NetworkStatus } from '@cbridge-utils/network';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { markupProfileListSelector } from '@cbridge-packages/markup-profile';
import { markupProfileAsNavigationItem } from './_helpers/markupProfileAsNavigationItem';

export const markupProfilesNavigationPropsSelector = createCachedSelector(
  [
    path(markupProfileListSelector).list(),
    path(markupProfileListSelector).networkStatus(),
  ],
  (markupProfileList, networkStatus) => {
    return {
      items: markupProfileList.map(markupProfileAsNavigationItem),
      isLoading: networkStatus !== NetworkStatus.Done && networkStatus !== NetworkStatus.Failed,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
